export default __webpack_public_path__ + "static/media/recyclingpioneers.50486746.png";